import React, { useContext, useEffect, useState, useCallback } from "react";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { filterDataContext } from "../../../App";
import SortingMenu from "../FilterSorting/SortingMenu";
import {
  ChangeSportTypeforApi,
  SportTypeToShow,
  getCrossIcon,
  getCurrentDate,
} from "../../../utils/func";
import { getDataFromApi } from "../../../APIs";
import {
  EVENTS_API,
  PRELOADTEAMS,
  PRELOADTOURNAMENTS,
  SPORTSLIST_API,
  VENUES_API,
} from "../../../constants";
import { useSearchParams } from "react-router-dom";
import MobileFilter from "../../MobileFilter";
import { createTabContentData } from "../../../constants/TextContainer";
import useWindowDimensions from "../../../hooks/useDimensions";

const sortOption = [
  {
    sort: "By Date",
  },
  {
    sort: "By Price",
  },
];

const FilterHeader = () => {
  const { width, height } = useWindowDimensions();
  const {
    selectedSport,
    setSelectedSport,
    setFilteredParams,
    filteredParams,
    setFilteredEvents,
    setPreloadTournamentData,
    preloadTournamentData,
    filteredEventParams,
    setFilteredEventParams,
    teamsData,
    setTeamsData,
    preLoadVenues,
    setPreloadVenues,
    setMaxPriceInput,
    setMinPriceInput,
    setTicketAvailabiltyInput,
    currentSortingTab,
    setCurrentSortingTab,
    showSorting,
    setShowSorting,
    setFilterSearchInput,
    checkTeamDataLength,
    setCheckTeamDataLength,
    setFilterLoader,
    preloadTeams,
    setPreloadTeams,
  } = useContext(filterDataContext);
  const [sort, setSort] = useState(false);
  const [selectSort, setSelectSort] = useState("");
  const { sportsList } = useContext(filterDataContext);
  const [searchParams, setSearchParams] = useSearchParams();

  let Sport_type = searchParams.get("sport_type");

  useEffect(() => {
    setSelectedSport(Sport_type === "football" ? "soccer" : Sport_type);
  }, [Sport_type]);

  useEffect(() => {
    getParams();
  }, [
    searchParams.get("team_name"),
    searchParams.get("tournament_name"),
    searchParams.get("country"),
    searchParams.get("city"),
    searchParams.get("venue"),
    searchParams.get("date_start"),
    searchParams.get("date_stop"),
    searchParams.get("minPrice"),
    searchParams.get("maxPrice"),
    searchParams.get("ticket_Availability"),
  ]);

  useEffect(() => {
    if (filteredParams) {
      if (filteredParams.length > 0) {
        getEventsResult();
      } else {
        setFilteredEventParams("");
      }
    }
  }, [filteredParams]);

  const checkTeamForSportType = useCallback(async () => {
    let result;
    if (preloadTeams?.length === 0) {
      result = await getDataFromApi(
        `/teams?sport_type=${ChangeSportTypeforApi(selectedSport)}`
      );
    } else {
      result = preloadTeams?.filter(
        (item) => item.sport_type === ChangeSportTypeforApi(selectedSport)
      );
    }
    setCheckTeamDataLength(result ? result.length === 0 : true);
  }, [selectedSport]);

  useEffect(() => {
    if (selectedSport) {
      checkTeamForSportType();
    }
    setCurrentSortingTab(createTabContentData()[0].CategoryName);
  }, [selectedSport, checkTeamForSportType]);

  const getAndSetData = async (url) => {
    setFilterLoader(true);
    const result = await getDataFromApi(url + `&sport_type=${selectedSport}`);
    setFilterLoader(false);
    if (result) {
      return result.data.data;
    }
    return [];
  };

  const getParams = () => {
    let params = [];
    for (const [key, value] of searchParams) {
      if (
        key === "team_name" ||
        key === "tournament_name" ||
        key === "country" ||
        key === "city" ||
        key === "venue" ||
        key === "date_start" ||
        key === "date_stop" ||
        key === "minPrice" ||
        key === "maxPrice" ||
        key === "ticket_Availability"
      ) {
        params.push({ key: key, value: value });
      }
    }
    setFilteredParams(params);
  };

  const handleResetFilters = () => {
    setSearchParams({ sport_type: searchParams.get("sport_type") });
    setMaxPriceInput("");
    setMinPriceInput("");
    setTicketAvailabiltyInput("");
    setFilterSearchInput("");
  };

  const getData = async (url) => {
    let response = await getDataFromApi(url);
    if (response) {
      return response.data.data;
    }
  };

  const getTeams = async (value) => {
    let teamsData;
    if (preloadTeams?.length === 0) {
      teamsData = await getData(PRELOADTEAMS);
    } else {
      teamsData = preloadTeams;
    }
    let filteredTeam = teamsData?.filter((item) => {
      if (item.official_name === value) {
        return item.team_id;
      }
    });
    if (filteredTeam.length > 0) {
      return filteredTeam[0]?.team_id;
    }
  };

  const getTournamentID = async (value) => {
    let tournamentData;
    if (preloadTournamentData.length === 0) {
      tournamentData = await getData(PRELOADTOURNAMENTS);
      setPreloadTournamentData(tournamentData);
    } else {
      tournamentData = preloadTournamentData;
    }
    let filteredCompetition = tournamentData?.filter((item) => {
      if (item.slug === value) {
        return item;
      }
    });
    if (filteredCompetition.length > 0) {
      return filteredCompetition[0].tournament_id;
    }
  };

  const getVenueID = async (value) => {
    let venuesData;
    if (preLoadVenues?.length === 0) {
      venuesData = await getData(VENUES_API);
    } else {
      venuesData = preLoadVenues;
    }
    if (venuesData) {
      let filteredVenue = venuesData?.filter((item) => {
        if (item.official_name === value) {
          return item;
        }
      });
      return filteredVenue[0]?.venue_id;
    }
  };

  const getEventsFilters = async () => {
    let eventsFilter = [];
    for (const item of filteredParams) {
      if (item.key === "team_name") {
        let team_id = await getTeams(item.value);
        if (team_id) {
          eventsFilter.push(`team_id=${team_id}`);
        }
      }
      if (item.key === "tournament_name") {
        let tournament_id = await getTournamentID(item.value);
        if (tournament_id) {
          eventsFilter.push(`tournament_id=${tournament_id}`);
        }
      }
      if (item.key === "country") {
        eventsFilter.push(`country=${item.value}`);
      }
      if (item.key === "city") {
        eventsFilter.push(`city=${item.value}`);
      }
      if (item.key === "venue") {
        let venue_id = await getVenueID(item.value);
        if (venue_id) {
          eventsFilter.push(`venue_id=${venue_id}`);
        }
      }
      const dateStartIndex = eventsFilter.findIndex((filter) =>
        filter.startsWith("date_start=")
      );
      if (dateStartIndex === -1 && !item.date) {
        eventsFilter.push(`date_start=${getCurrentDate()}`);
      }
      if (item.key === "date_start") {
        eventsFilter = eventsFilter.filter(
          (filter) => !filter.startsWith("date_start=")
        );
        eventsFilter.push(`date_start=${item.value}`);
      }
      if (item.key === "date_stop") {
        eventsFilter.push(`date_stop=${item.value}`);
      }
      const minPriceIndex = eventsFilter.findIndex((filter) =>
        filter.startsWith("min_ticket")
      );
      if (minPriceIndex === -1 && !item.min_ticket_price_eur) {
        eventsFilter.push(`min_ticket_price_eur=1`);
      }
      if (item.key === "minPrice") {
        eventsFilter = eventsFilter.filter(
          (filter) => !filter.startsWith("min_ticket")
        );
        eventsFilter.push(`min_ticket_price_eur=${item.value}`);
      }
      if (item.key === "maxPrice") {
        eventsFilter.push(`max_ticket_price_eur=${item.value}`);
      }
      const ticketAvailabilityIndex = eventsFilter.findIndex((filter) =>
        filter.startsWith("tickets")
      );
      if (ticketAvailabilityIndex === -1 && !item.tickets_available) {
        eventsFilter.push(`tickets_available=1`);
      }
      if (item.key === "ticket_Availability") {
        eventsFilter = eventsFilter.filter(
          (filter) => !filter.startsWith("tickets")
        );
        eventsFilter.push(`tickets_available=${item.value}`);
      }
    }
    return eventsFilter;
  };

  const getEventsResult = async () => {
    let eventsFilter = await getEventsFilters();
    if (eventsFilter.length > 0) {
      let sorting = "&sorting=date_start ASC";
      if (selectSort === "By Date") {
        sorting = "&sorting=date_start ASC";
      } else if (selectSort === "By Price") {
        sorting = "&sorting=min_ticket_price_eur ASC";
      }
      const queryString = eventsFilter.join("&");
      const combinedQueryString = queryString + sorting;
      setFilteredEventParams(combinedQueryString);
      const combinedResults = await getAndSetData(
        `${EVENTS_API}${combinedQueryString}`
      );
      setFilteredEvents(combinedResults);
    } else {
      setFilteredEvents([]);
      setFilteredEventParams("");
    }
  };

  useEffect(() => {
    if (selectSort.length > 0) {
      getEventsResult();
    }
  }, [selectSort]);

  const handleSportClick = (sport_id) => {
    handleResetFilters();
    setSearchParams({
      sport_type: sport_id === "soccer" ? "football" : sport_id,
    });
  };

  const handleSortClick = (sort) => {
    setSelectSort(sort);
  };

  const getClasses = (CategoryName) => {
    let data = getCrossIcon(CategoryName, filteredParams);
    let selectedFilterTab = data?.length > 0 ? "selectedActive" : "";
    let currentActiveTab = currentSortingTab === CategoryName ? "active" : "";
    if (selectedFilterTab && currentActiveTab) {
      return currentActiveTab;
    } else {
      return currentActiveTab + " " + selectedFilterTab;
    }
  };

  return (
    <>
      {width <= 768 && (
        <MobileFilter
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      )}
      <div className="Filter mobile_hide">
        <div className="filter_flex">
          <div className="filter_names">
            <ul>
              {sportsList
                ?.filter((sport) => {
                  return sport.sport_id !== "formula1";
                })
                .map((sport) => (
                  <li
                    key={sport.sport_id}
                    onClick={() => {
                      handleSportClick(sport.sport_id);
                    }}
                    className={selectedSport === sport.sport_id ? "active" : ""}
                  >
                    {SportTypeToShow(sport.sport_id)}
                  </li>
                ))}
            </ul>
          </div>
          <div className="filter_btn">
            <button onClick={() => setShowSorting(!showSorting)}>
              Filter{" "}
              <span>
                <FontAwesomeIcon icon={faCaretDown} />
              </span>
            </button>
          </div>
        </div>
        {showSorting && (
          <div className="filterd_section">
            <div className="content_sec">
              <div className="content_headrr">
                <ul>
                  {createTabContentData()
                    .filter((item) => {
                      if (checkTeamDataLength === true) {
                        return item.CategoryName !== "Team";
                      } else {
                        return item;
                      }
                    })
                    .map(({ id, CategoryName }, index) => (
                      <li key={id} className={getClasses(CategoryName)}>
                        <label htmlFor={id} className="radio-container">
                          {CategoryName}
                          <input
                            type="checkbox"
                            value={CategoryName}
                            name="filterOption"
                            id={id}
                            onChange={(e) => {
                              setCurrentSortingTab(e.target.value);
                            }}
                            checked={currentSortingTab === CategoryName}
                          />
                          {/* {
                               getCrossIcon(CategoryName, filteredParams).length > 0 ?  */}
                          <span className="radio-checkmark"></span>
                          {/* } */}
                        </label>
                      </li>
                    ))}
                </ul>
                <div className="reset_filter">
                  <button onClick={handleResetFilters}>Reset Filters </button>
                  <div
                    onClick={() => {
                      setSort(!sort);
                    }}
                    className="sort"
                  >
                    Sort{" "}
                    <span>
                      {" "}
                      <FontAwesomeIcon icon={faCaretDown} />
                    </span>
                    {sort === true && (
                      <div className="sort_options">
                        {sortOption.map((item, index) => {
                          return (
                            <h1
                              onClick={() => {
                                handleSortClick(item.sort);
                              }}
                              className={
                                selectSort === item.sort
                                  ? "sortOptionSelectBackground"
                                  : ""
                              }
                              key={index}
                            >
                              {item.sort}
                            </h1>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="search_result">
                <SortingMenu
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  currentSortingTab={currentSortingTab}
                  selectSort={selectSort}
                  setShowSorting={setShowSorting}
                  showSorting={showSorting}
                  getParams={getParams}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default FilterHeader;
